{
  "version": 1,
  "api": "http://localhost:3011/v1",
  "apiLive": "https://core-api-633982788522.europe-north1.run.app/v1",
  "map": {
    "tileUrl": "https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png",
    "attribution": "Kartendaten: &copy; <a href=\"https://www.openstreetmap.org/copyright\">OpenStreetMap</a>-Mitwirkende, SRTM | Kartendarstellung: &copy; <a href=\"https://opentopomap.org/\">OpenTopoMap</a> (<a href=\"https://creativecommons.org/licenses/by-sa/3.0/\">CC-BY-SA</a>)",
    "maxZoom": 17
  }
}
